import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import OInput from '../../../UI/FormControls/OInput';
import { useTranslation } from 'react-i18next';
import TextArea from '../../../UI/FormControls/TextArea';
import DragAndDrop from '../../../UI/DragAndDrop';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import noImage from '../Image/noImage.png';
import CheckBox from '../../../UI/FormControls/CheckBox';
import MyButton from '../../../UI/myButton/MyButton';

const Inputs = ({
  formValues,
  setFormValues,
  handleSlika,
  slika,
  listaMasina,
  kategorijaDelova,
}) => {
  const [disable, setDisable] = useState(true);
  const { t, i18n } = useTranslation();
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(name);
    console.log(event.target.checked);
    if (typeof formValues[name] === 'boolean') {
      setFormValues((curr) => {
        return { ...curr, [name]: event.target.checked };
      });
    } else {
      setFormValues((prevData) => ({ ...prevData, [name]: value }));
    }
  };
  const handleClickMasina = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idMasine: item.id,
        nazivMasine: item.vrednost,
      };
    });
  };
  const handleClickKategorijaDelova = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idKategorijeDela: item.id,
        nazivKategorijeDela: item.vrednost,
        marza: null,
        marzaCount: (+item.marza).toFixed(2),
        prodajnaCena: item.marza
          ? (+formValues.nabavnaCena * (1 + item.marza / 100)).toFixed(2)
          : '',
      };
    });
    setDisable(true);
  };
  const handleUnesiMarzu = (item) => {
    setDisable(false);
  };
  const countPrice = (event) => {
    if (event.target.name === 'nabavnaCena') {
      setFormValues((curr) => {
        const value = +event.target.value;
        const calculatedPrice =
          value * (1 + (formValues.marza || formValues.marzaCount) / 100);
        return {
          ...curr,
          prodajnaCena: value === 0 ? '' : calculatedPrice.toFixed(2),
          [event.target.name]: value === 0 ? '' : value.toFixed(2),
        };
      });
    }
    if (event.target.name === 'prodajnaCena') {
      if (+event.target.value === formValues.prodajnaCena) {
        return;
      }
      setFormValues((curr) => {
        return {
          ...curr,
          marza: (
            (+event.target.value / +formValues.nabavnaCena - 1) *
            100
          ).toFixed(2),
          [event.target.name]: (+event.target.value).toFixed(2),
        };
      });
    }
    if (event.target.name === 'marza') {
      setFormValues((curr) => {
        return {
          ...curr,
          prodajnaCena: (
            formValues.nabavnaCena *
            (1 + +event.target.value / 100)
          ).toFixed(2),
          [event.target.name]: (+event.target.value).toFixed(2),
        };
      });
    }
  };
  useEffect(() => {
    // na editu kada se marza ne vrati kroz listu nego je null izvlaci se iz kategorijaDelova
    const foundItem = kategorijaDelova.find(
      (item) => item.id === formValues.idKategorijeDela,
    );
    if (foundItem) {
      setFormValues((curr) => ({
        ...curr,
        marzaCount: foundItem.marza,
      }));
    }
  }, [formValues.idKategorijeDela]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
      }}
    >
      <OInput
        label={t('name')}
        name="naziv"
        value={formValues.naziv}
        handleChange={handleInputChange}
      />
      <OInput
        label={t('partNumber')}
        name="partNumber"
        value={formValues.partNumber}
        handleChange={handleInputChange}
      />
      <TextArea
        label={t('description')}
        name="opis"
        value={formValues.opis}
        handleChange={handleInputChange}
        style={{ width: '100%', height: '60px' }}
      />
      <OAutocomplete
        data={listaMasina}
        value={formValues.nazivMasine}
        handleClick={handleClickMasina}
        label="Mašine"
        style={{ width: '100%', height: '60px' }}
      />
      <OAutocomplete
        data={kategorijaDelova}
        value={formValues.nazivKategorijeDela || ''}
        handleClick={handleClickKategorijaDelova}
        label="Kategorija"
        style={{ width: '100%', height: '60px' }}
      />
      <OInput
        type="number"
        label="Nabavna cena"
        name="nabavnaCena"
        value={formValues.nabavnaCena}
        handleChange={handleInputChange}
        onBlur={countPrice}
        onEnter={countPrice}
      />
      <div style={{ display: 'flex', gap: '10px' }}>
        <OInput
          type="number"
          label="Marža (%)"
          name="marza"
          value={
            formValues.marza === 0
              ? '0'
              : formValues.marza !== null
              ? formValues.marza
              : formValues.marzaCount
          }
          handleChange={handleInputChange}
          disabled={disable}
          onEnter={countPrice}
          onBlur={countPrice}
          style={{ width: '75%' }}
        />
        <MyButton
          onClick={handleUnesiMarzu}
          label="Unesi maržu ručno"
          icon="fas fa-pen"
          style={{ width: '25%' }}
        />
      </div>
      <OInput
        type="number"
        label="Prodajna cena"
        name="prodajnaCena"
        value={formValues.prodajnaCena}
        handleChange={handleInputChange}
        onBlur={countPrice}
        onEnter={countPrice}
      />
      <div style={{ display: 'flex', gap: '10px' }}>
        <CheckBox
          style={{ height: '70px' }}
          label="Favorit"
          handleChange={handleInputChange}
          checked={formValues.favorit}
          name="favorit"
        />
        <CheckBox
          style={{ height: '70px' }}
          label="Akcija"
          handleChange={handleInputChange}
          checked={formValues.akcija}
          name="akcija"
        />
        <CheckBox
          style={{ height: '70px' }}
          label="Prikži u prodavnici"
          handleChange={handleInputChange}
          checked={formValues.prikazNaShopu}
          name="prikazNaShopu"
        />
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: '1' }}>
          <DragAndDrop
            handleFiles={handleSlika}
            maxFiles={1}
            addedFiles={slika}
            handleRemoveFile={() => {
              handleSlika([]);
            }}
            title="Dodavanje slike dela"
          />
        </div>
        <div style={{ flex: '1', textAlign: 'center' }}>
          {/* {formValues.slikaB64 && (
            <img
              style={{ height: '120px' }}
              alt="noImage"
              src={`data:image/jpeg;base64,${formValues.slikaB64}`}
            />
          )} */}
          {formValues.slikaB64 ? (
            formValues.slikaB64.startsWith('blob:') ? (
              <img
                style={{ height: '120px' }}
                alt="noImage"
                src={formValues.slikaB64}
              />
            ) : (
              <img
                style={{ height: '120px' }}
                alt="noImage"
                src={`data:image/jpeg;base64,${formValues.slikaB64}`}
              />
            )
          ) : (
            <img
              style={{ height: '120px' }}
              alt="noImage"
              src={noImage} // Zamenite sa stvarnom putanjom do zamenske slike
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Inputs;
